import React from 'react';
import { LeadForm } from '../../components/LeadForm';
export function AfterSchoolHeroForm() {
  return <div className="bg-paper p-8 rounded-2xl shadow-2xl border border-subtle-gray relative" data-id="element-644">
      <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-storm-red text-white px-6 py-2 rounded-full font-bold uppercase tracking-wide whitespace-nowrap shadow-lg" data-id="element-645">
        Find Your Class
      </div>
      <div className="mt-4" data-id="element-646">
        <LeadForm buttonText="Claim Your Child's Free Week" data-id="element-647" />
      </div>
    </div>;
}